<script>
	import ChatTemplateSelect from "./../../components/ChatTemplateSelect.svelte";
	import CustomContentBuilder from "./CustomContentBuilder.svelte";
	import RagDocumentManager from "./RagDocumentManager.svelte";
	import { Section, Textarea, Button } from "../../lib/ui";
	import { personaLevelRuleHit } from "./stepLint";
	export let chat;
	export let handleTextareaNextbreak;

	let tab = "detail";
	// 레벨 지시문(학습자 정보 → 레벨마다 말하는 방식)이 있는 챗에서만 — 그때 persona 의 문장 길이 규칙은 레벨과 부딪힌다.
	//   레벨이 없는 챗(FAQ·캐릭터 봇)에서는 persona 가 말 길이를 정하는 게 정상이라 띄우지 않는다(stepLint PERSONA_LEVEL_RULE).
	$: hasLevelGuides = (chat.traits || []).some((t) => Object.keys(t?.guide?.map || {}).length);
	$: personaHit = hasLevelGuides ? personaLevelRuleHit(chat.characterPersona) : "";
	import {
		showLoadingPopup,
		hideLoadingPopup,
	} from "./../store/loadingPopupStore.js";

	const clickPromptGenerate = () => {
		const isRequired = chat.checkRequiredPromptFields();
		if (isRequired) {
			return;
		}
		const param = chat.getRequirePromptGenerate();
		showLoadingPopup("promptCreate");
		PRConnect.send("/api/Chat/promptGenerate", param, (data) => {
			if (data.header.status === "success") {
				hideLoadingPopup();
				const generatedPrompt = data.result;
				chat.setGeneratedPrompt(generatedPrompt);
			}
		});
	};
</script>

{#if chat.isCurrentTab(tab)}
	<div class="tw-space-y-4 tw-font-sans tw-text-foreground">
		<Section
			title={chat.isCharacterChat()
				? "AI챗 설명을 작성해주세요!"
				: "브랜드/서비스 소개를 작성해주세요!"}
			required
		>
			<Textarea
				class="tw-max-h-[300px]"
				rows={chat.getCharacterUniverseRows()}
				value={chat.characterUniverse}
				placeholder={chat.isCharacterChat()
					? "프로필에 노출되는 설명입니다. AI챗의 특징, 컨셉, 스토리 등 간단한 설명을 작성해주세요!"
					: "프로필에 노출되는 소개입니다. 브랜드/서비스의 특징, 주요 제공 내용 등을 간단히 소개해주세요!"}
				on:change={(e) => chat.change("characterUniverse", e.target.value)}
				on:input={(e) => handleTextareaNextbreak(e, "characterUniverse")}
			/>
		</Section>

		{#if chat.isCharacterChat()}
			<ChatTemplateSelect {chat} />
		{/if}

		{#if chat.primaryOptionId === 4}
			<CustomContentBuilder {chat} />
		{:else}
			<Section title="AI챗의 프롬프트를 작성해주세요!" required>
				<svelte:fragment slot="badge">
					{#if chat.isCharacterChat() && chat.isAutoGenerateOption()}
						<Button variant="outline" size="sm" on:click={clickPromptGenerate}>
							자동 생성
						</Button>
					{/if}
				</svelte:fragment>
				<Textarea
					class="tw-max-h-[300px]"
					rows={chat.getCharacterPersona()}
					value={chat.characterPersona}
					placeholder={chat.isCharacterChat()
						? "원하는 대화 스타일과 응답 방향을 자세히 입력해보세요. 말투, 역할, 답변 방식을 상세히 입력할수록 정확도가 높아져요!"
						: "브랜드/서비스 안내, 자주 묻는 질문 답변, 응대 톤앤매너 등을 구체적으로 입력할수록 정확도가 높아져요!"}
					on:change={(e) => chat.changeCharacterPersona(e.target.value)}
					on:input={(e) => handleTextareaNextbreak(e, "characterPersona")}
				/>
				{#if personaHit}
					<p style="margin:6px 0 0;font-size:11px;line-height:1.5;color:hsl(var(--sb-destructive));">
						‘{personaHit}’ — 말의 난이도(문장 길이·어휘)는 [대화 설정]의 레벨마다 말하는 방식이 맡아요. 여기엔 성격과 말투(반말·존댓말)만
						적어 주세요. 둘 다 적으면 높은 레벨에서 서로 부딪혀요.
					</p>
				{/if}
			</Section>
		{/if}

		<!-- RAG 문서 기반 답변 설정 (USE_RAG는 문서 저장/삭제 시 자동 관리) -->
		<RagDocumentManager {chat} />
	</div>
{/if}
